import * as R from 'ramda'
import React, { useState } from 'react'
import { useRouter } from 'next/router'
import { useSession } from 'context/Session'
import { FollowButton, FeedBadge } from 'components/elements'
import { getCloudFlareImgVariant } from 'components/helpers/withSizes'
import { Modal, KarmaMedal } from 'components/elements'

import * as S from './Header.styles'

import { refLinkMap } from '../../modules/constants'

const defaultProps = {}
const propTypes = {}

export const Header = ({ profile: _profile, hasFollow, disableEdit }) => {
  const { user } = useSession()
  const router = useRouter()
  const [isModal, setModal] = useState(false)

  const profile = _profile || user?.profile

  return (
    <S.Container>
      <S.AvatarContainer>
        <S.Avatar>
          {profile?.profileImage ? (
            <S.ImgProfile
              data-test="icon"
              src={getCloudFlareImgVariant(profile?.profileImage, {
                default: 'profileDetail',
              })}
              alt="article"
              layout="fill"
              objectFit="cover"
              objectPosition="center"
              quality={90}
              priority
              loading="eager"
            />
          ) : (
            profile && R.head(profile?.username || 'U')
          )}
        </S.Avatar>
        {!disableEdit && (
          <S.EditButton onClick={() => router.push('/settings')} />
        )}
      </S.AvatarContainer>
      <S.Content>
        <S.Title>
          {profile &&
            `${profile?.firstName || profile?.username || ''} ${
              profile?.lastName || ''
            }`}
          {hasFollow && (
            <FollowButton
              style={{ marginLeft: 10 }}
              size="medium"
              key={`follow-${profile?.username}`}
              username={profile?.username}
            />
          )}
        </S.Title>
        {!R.isEmpty(profile?.references || []) && (
          <S.Links>
            {profile?.references?.map(refLink => {
              if (!refLink?.value) {
                return null
              }
              const { Icon, baseUrl } =
                refLinkMap[refLink?.type] || refLinkMap.other

              const link = baseUrl + refLink?.value

              return (
                <S.RefLink
                  key={`refLink-${refLink?.type}`}
                  href={link}
                  target="_blank"
                  rel="noreferrer"
                >
                  <Icon />
                </S.RefLink>
              )
            })}
          </S.Links>
        )}
        <S.InfoContainer>
          {profile?.registeredPhysicianVerified && (
            <FeedBadge
              label="Verified Physician"
              type="physician"
              style={{ margin: '0 0 10px' }}
            />
          )}
          <S.Info style={{ cursor: 'pointer' }} onClick={() => setModal(true)}>
            <S.InfoTitle>Merit</S.InfoTitle>
            <S.KarmaValue>
              <KarmaMedal value={profile?.karma} />
              &nbsp;
              {profile?.karma || 0}
            </S.KarmaValue>
          </S.Info>
        </S.InfoContainer>
        <S.Name>
          {profile?.position &&
            `${profile?.position} at ${profile?.company}${
              profile?.singleLineStatement
                ? ` | ${profile?.singleLineStatement}`
                : ''
            }`}
        </S.Name>
        <S.Desc
          value={profile?.bio || ''}
          style={{ gridColumn: '2 / 3', gridRow: '3 / 5', width: '100%' }}
        />
      </S.Content>
      <Modal
        isOpen={isModal}
        close={() => setModal(false)}
        closeOnOutside={false}
      >
        <S.MeritInfo />
      </Modal>
    </S.Container>
  )
}

Header.defaultProps = defaultProps
Header.propTypes = propTypes

export default Header
